import { render, staticRenderFns } from "./EditorWppEmailPanel.vue?vue&type=template&id=0fb5cf71&scoped=true"
import script from "./EditorWppEmailPanel.vue?vue&type=script&lang=js"
export * from "./EditorWppEmailPanel.vue?vue&type=script&lang=js"
import style0 from "./EditorWppEmailPanel.vue?vue&type=style&index=0&id=0fb5cf71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb5cf71",
  null
  
)

export default component.exports